/**
 * Removes keys with null or undefined values from an object. Use with caution.
 *
 * @param {Object} obj - The object to sanitize
 * @returns {Object} - A new object containing only the keys with values that are not null or undefined
 *
 * @example
 * initialObject = { a: 1, b: null, c: undefined, d: 'text' }
 *
 * sanitizedObject = omitNil(initialObject)
 * // Result: { a: 1, d: 'text' }
 *
 */
export const omitNil = <T extends Record<string, any>>(obj: T): Partial<T> =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null)) as Partial<T>;
